import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CREDIT_CARD_CONFIG } from './configs/credit-card.config';
import { CreditCardCongif } from './interfaces/credit-card-config.interface';
import { CreditCardControl } from './interfaces/credit-card-control.interface';

@Injectable()
export class CreditCardService {

  subject$ = new Subject<CreditCardControl>();
  subjectInputValue$ = new Subject<CreditCardControl>();

  constructor(@Inject(CREDIT_CARD_CONFIG) private creditCardConfig: CreditCardCongif) { }

  getConfig(): CreditCardCongif {
    return {
      cardFront: {
        labelInitialCardNumber: this.creditCardConfig.cardFront?.labelInitialCardNumber || '•••• •••• •••• ••••',
        labelInitialDateValid: this.creditCardConfig.cardFront?.labelInitialDateValid || '••/••',
        labelInitialPersonName: this.creditCardConfig.cardFront?.labelInitialPersonName || 'Nombre de la persona',
        labelValidUntilText: this.creditCardConfig.cardFront?.labelValidUntilText || 'Valido Hasta',
        labelMonthYear: this.creditCardConfig.cardFront?.labelMonthYear || 'MM/YY'
      },
      cardBack: {
        labelInitialCVC: this.creditCardConfig.cardBack?.labelInitialCVC || '•••',
        labelTextFooter: this.creditCardConfig.cardBack?.labelTextFooter || 'This card has been issued by Oscar Del Rio and is licensed for anyone to use anywhere for free.'
      }

    }
  }

}
